import { useTranslation } from 'react-i18next';

import { MultiSelect } from '@/common';
import { COLORS } from '@/enums';
import { useGetEventTags } from '@/services';
import { AssetTagFilterProps, SelectOptionProps, Tag } from '@/types';

export const AssetsTagFilter = ({
  eventId,
  selectedTags,
  setSelectedTags
}: AssetTagFilterProps) => {
  const [t] = useTranslation('common');
  const { status, data: allTags } = useGetEventTags(eventId);

  return (
    <div className='w-1/2 md:w-full'>
      {status !== 'loading' && allTags?.data && (
        <MultiSelect
          className='w-full md:w-36'
          label=''
          id='assetTagFilter'
          placeholder={t('labels')}
          options={allTags?.data.map((tag: Tag) => ({ value: tag.id, label: t(tag.name) }))}
          handleChange={(value) => setSelectedTags(value as SelectOptionProps[])}
          selectedValues={selectedTags ?? []}
          textColor={COLORS.PRIMARY_BLUE}
          borderStyle={`1px solid ${COLORS.PRIMARY_BLUE}`}
          fontWeight='700'
          dropdownIndicatorColor={COLORS.PRIMARY_BLUE}
          controlShouldRenderValue={false}
        />
      )}
    </div>
  );
};
